export default __webpack_public_path__ + "static/media/location.ea200df6.svg";